import React, { useState, useCallback } from 'react';
import { getAllUpcomingReservations } from '../../../services/OrderService';
import ReservationList from '../../components/Orders/ReservationList';

const Reservations = () => {
    const [reservationList, setReservationList] = useState();
    const sort = 3;
    const [pagination, setPagination] = useState()

    const getUpcomingReservations = useCallback(() => {
        getAllUpcomingReservations().then(res => {
            res.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
            setPagination(Array(Math.ceil(res.length / sort))
                .fill()
                .map((_, i) => i + 1));
            setReservationList(res);
        });
    }, []);
    return (
        <ReservationList reservationList={reservationList}
            getUpcomingReservations={getUpcomingReservations}
            pagination={pagination}
            sort={sort}
        />
    );
}

export default Reservations;
